<div class="user-card" (click)="onCardClick()">
  <ng-container *ngFor="let col of columns">
    <ng-container [ngSwitch]="col.colType">
      <!-- USER -->
      <div *ngSwitchCase="'user'" class="user-info">
        <div class="avatar">
          <img
            *ngIf="item.avatar"
            src="{{ 'data:image/png;base64,' + item.avatar }}"
            alt="{{ item.name }}"
            class="rounded-circle"
            style="width: 100%; height: 100%; object-fit: cover"
          />
          <div
            *ngIf="!item.avatar"
            class="no-image d-flex align-items-center justify-content-center text-weight-500 text-size-15 rounded-circle amts-bg-el1 amts-text-el2"
          >
            {{ item.name?.substring(0, 1)?.toUpperCase() }}
          </div>
        </div>

        <div class="details">
          <div class="name text-size-16 text-weight-500 text-nowrap">
            {{ item.name }}
            <span *ngIf="item.age">, {{ item.age }} , {{ item.gender }}</span>
          </div>
        </div>
      </div>

      <div *ngSwitchCase="'name'" class="name-info">
        <div class="name text-size-16 text-weight-500 text-nowrap">
          {{ item.name }}
        </div>
      </div>

      <!-- DATA (Role, LastLogin, Status vs.) -->
      <div *ngSwitchCase="'data'" class="data-item">
        <!-- Başlık -->
        <span class="data-label">
          {{ col.mobileLabel || col.labelKey }}
        </span>

        <!-- Değer: kolon key'ine göre map -->
        <!-- Role (User List) -->
        <span class="data-value" *ngIf="col.key === 'Role'">
          {{ item.role || "-" }}
        </span>

        <!-- Phone (Patient List) -->
        <span class="data-value" *ngIf="col.key === 'Phone'">
          {{ item.phone || "-" }}
        </span>

        <!-- Patient ID (Patient List) -->
        <span class="data-value" *ngIf="col.key === 'PatientID'">
          {{ item.patientID || "-" }}
        </span>

        <!-- Created Date (Patient List) -->
        <span class="data-value" *ngIf="col.key === 'CreatedDate'">
          {{ item.createdDate | date: "dd.MM.yyyy" }}
        </span>

        <!-- Last Login (User List) -->
        <span class="data-value" *ngIf="col.key === 'LastLogin'">
          {{ item.lastLoginDate | date: "dd.MM.yyyy" }}
        </span>

        <!-- BirthDate (Patient List) -->
        <span class="data-value" *ngIf="col.key === 'BirthDate'">
          {{ item.birthDate | date: "dd.MM.yyyy" }}
        </span>

        <span class="data-value" *ngIf="col.key === 'WoundCategory'">
          {{ getWoundCategoryText(item.woundCategoryType) | translate }}
        </span>
        <span class="data-value" *ngIf="col.key === 'WoundType'">
          {{ getWoundTypeText(item.woundType) | translate }}
        </span>
        <span class="data-value" *ngIf="col.key === 'WoundStatus'">
          <span
            class="user-status-text"
            [ngClass]="getWoundStatusClass(item.woundStatus)"
          >
            {{ getWoundStatusText(item.woundStatus) | translate }}
          </span>
        </span>

        <!-- Status -->
        <span class="data-value" *ngIf="col.key === 'Status'">
          <span
            *ngIf="item.userStatus !== undefined && item.userStatus !== null"
            class="user-status-text"
            [ngClass]="getUserStatusTextClass(item.userStatus)"
          >
            {{ getUserStatusText(item.userStatus) }}
          </span>
          <span
            *ngIf="
              item.patientStatus !== undefined && item.patientStatus !== null
            "
            class="user-status-text"
            [ngClass]="getCaseStatusClass(item.patientStatus)"
          >
            {{ getCaseStatusText(item.patientStatus) }}
          </span>
          <span
            *ngIf="
              item.appointmentStatus !== undefined &&
              item.appointmentStatus !== null
            "
            [ngClass]="getAppointmentStatusClass(item.appointmentStatus)"
          >
            {{ getAppointmentStatusText(item.appointmentStatus) | translate }}
          </span>
        </span>

        <span class="data-value" *ngIf="col.key === 'nurseName'">
          {{ item.nurseName || "-" }}
        </span>

        <span class="data-value" *ngIf="col.key === 'doctorName'">
          {{ item.doctorName || "-" }}
        </span>

        <span class="data-value" *ngIf="col.key === 'managerName'">
          {{ item.managerName || "-" }}
        </span>

        <div class="data-value" *ngIf="col.key === 'assignedToMe'">
          <button class="btn btn-sm btn-assign" (click)="onAssignToMe($event)">
            <span class="ms-1">
              {{ "Assign to me" | translate }}
            </span>
          </button>
        </div>

        <span class="data-value" *ngIf="col.key === 'consultationStatus'">
          <span
            class="user-status-text"
            [ngClass]="getConsultationStatusClass(item.consultationStatusRaw)"
          >
            {{
              getConsultationStatusText(item.consultationStatusRaw) | translate
            }}
          </span>
        </span>
      </div>

      <!-- ORGANIZATION / LOCATION -->
      <div *ngSwitchCase="'dataOrg'" class="data-item">
        <span class="data-label">
          {{ col.mobileLabel || col.labelKey }}
        </span>
        <span class="data-value" *ngIf="col.key === 'Organization'">
          {{ item.organization || "-" }}
        </span>
        <span class="data-value" *ngIf="col.key === 'Location'">
          {{ item.location || "-" }}
        </span>
        <span class="data-value" *ngIf="col.key === 'OrganizationCode'">
          {{ item.organizationCode || "-" }}
        </span>
      </div>

      <!-- EMAIL -->
      <div *ngSwitchCase="'dataEmail'" class="data-item">
        <span class="data-label">
          {{ col.mobileLabel || col.labelKey }}
        </span>
        <span class="data-value">
          {{ item.email || "-" }}
        </span>
      </div>

      <!-- ACTIONS -->
      <div
        *ngSwitchCase="'actions'"
        class="actions-item d-flex gap-2 align-items-center justify-content-start"
        (click)="$event.stopPropagation()"
      >
        <!-- Status toggle -->
        <button
          class="btn btn-icon btn-sm"
          (click)="onStatusToggle($event)"
          *ngIf="item.userStatus === 2 || item.userStatus === 3"
          title="Toggle status"
        >
          <i class="fa-regular fa-circle-half-stroke"></i>
        </button>

        <!-- Edit -->
        <button
          *ngIf="canEdit"
          type="button"
          class="btn btn-icon btn-sm"
          title="Edit"
          (click)="onEdit($event)"
        >
          <i class="fa-regular fa-pen-to-square"></i>
        </button>

        <!-- Delete -->
        <button
          *ngIf="canDelete"
          (click)="onDelete($event)"
          class="btn btn-icon btn-sm"
          title="Delete"
        >
          <i class="fa-regular fa-trash-can"></i>
        </button>

        <button
          *ngIf="assignToMe"
          (click)="onAssignToMe($event)"
          class="btn btn-icon btn-sm"
          title="Assign to Me"
        >
          <i class="fa-solid fa-user-check"></i>
        </button>

        <!-- Assign (for wounds) -->
        <button
          *ngIf="
            (item.woundStatus === 0 || item.woundStatus === 1) &&
            !this.permissionService.hasPermission('facility_admin_claim')
          "
          (click)="onAssign($event)"
          class="btn btn-icon btn-sm"
          title="Assign"
        >
          <i class="fa-solid fa-user-plus"></i>
        </button>

        <ng-container *appHasClaim="'facility_admin_claim'">
          <button
            *ngIf="item.woundStatus === 0 || item.woundStatus === 1"
            (click)="openAssignModal($event)"
            class="btn btn-icon btn-sm"
            title="Claim Wound"
          >
            <i class="fa-solid fa-clipboard-check"></i>
          </button>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</div>
